<template>
  <div class="selectInput">
    <lk-select v-model="val" :size='size' :class="{'showInput':showInput}" @on-change='handleChange' filterable>
      <lk-option v-for="(item,i) in options" :key="i" :value='item[keyName]'>{{item[name]}}</lk-option>
    </lk-select>
  <lk-input :maxlength='maxlength'  :size='size' style="width:50%" v-if="showInput" placeholder="请输入" v-model="str" @on-blur='handleBlur'></lk-input>
  </div>
</template>
<script>
export default {
  name: 'SelectInput',
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    size: {
      type: String,
      default: 'default',
    },
    value: {
    },
    maxlength: {
      type: Number,
      default: 10,

    },

    showValue: {// 指定input show值

    },
    name: {// 用于字段装换
      type: String,
      default: 'name',
    },
    keyName: {
      type: String,
      default: 'value',
    },
    otherStr: {
      type: String,
    },
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  computed: {
    showInput() {
      if (this.showValue) {
        return this.showValue === this.val;
      }
      return !!this.options.length && this.val === this.options[this.options.length - 1][this.keyName];
    },
  },
  watch: {
    value() {
      this.val = this.value;
      // this.str = this.otherStr;
    },
    otherStr() {
      // this.str = this.value;
      this.str = this.otherStr;
    },
    // val() {
    //   this.$emit('setOther', '');
    //   this.str = '';
    // },
  },
  data() {
    return {
      val: null,
      str: '',
    };
  },
  methods: {
    handleBlur() {
      this.$emit('setOther', this.str);
    },
    handleChange(val) {
      this.$emit('change', val);
      if (this.str) {
        this.$emit('setOther', '');
        this.str = '';
      }
    },
  },
  mounted() {
    this.val = this.value;
    this.str = this.otherStr;
  },
};
</script>
<style lang="less" scoped>
.selectInput{
  .showInput{
    width: 50%;
  }
}
</style>
